import {
  INCOMPLETE_ORDERS_REQUESTED,
  INCOMPLETE_ORDERS_SUCCESS,
  INCOMPLETE_ORDERS_FAILURE,
} from '../types';

const INITIAL_STATE = {
  orders: [],
  indexEndCursor: null,
  indexStartCursor: null,
  indexHasNextPage: null,
  indexHasPreviousPage: null,
  isFetching: false,
  status: 'waiting',
  errors: null
};

const incompleteOrders = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case INCOMPLETE_ORDERS_REQUESTED:
      return Object.assign({}, state, {
        orders: {},
        indexEndCursor: null,
        indexStartCursor: null,
        indexHasNextPage: null,
        indexHasPreviousPage: null,
        isFetching: true,
        status: 'requested',
        errors: null
      });

    case INCOMPLETE_ORDERS_SUCCESS:
      return Object.assign({}, state, {
        orders: action.payload.orders || [],
        indexEndCursor: action.payload.order_pagination.endCursor,
        indexStartCursor: action.payload.order_pagination.startCursor,
        indexHasNextPage: action.payload.order_pagination.hasNextPage,
        indexHasPreviousPage: action.payload.order_pagination.hasPreviousPage,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case INCOMPLETE_ORDERS_FAILURE:
      return Object.assign({}, state, {
        orders: {},
        ordersPagination: {},
        isFetching: false,
        status: 'error',
        errors: action.error
      });

    default:
      return state;
  }
}

export default incompleteOrders;
